angular.module("app").directive("sportTeamLogoModalDetail", () => {
  let link = (scope) => {
    scope.allData = {
      data: scope.logodata,
      index: scope.index,
    };

    scope.data = scope.logodata[scope.index];

    scope.LeftButtonHandler = () => {
      let index = scope.allData.index;
      if (index > 0) {
        index--;
      }
      scope.allData.index = index;
      scope.data = scope.allData.data[index];
    };

    scope.RightButtonHandler = () => {
      try {
        let index = scope.allData.index;
        if (index < scope.allData.data.length - 1) {
          index++;
        }
        scope.allData.index = index;
        scope.data = scope.allData.data[index];
      } catch (e) {}
    };

    scope.closeClickHandler = () => {
      scope.closefunction();
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareGooglePlus = (url) => {
      window.open("https://plus.google.com/share?url=" + url);
    };

    // dummy data
    scope.logoColorDummyData = [
      {
        title: "color name",
        hex: "#f0b417",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#dc4e1e",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#70992f",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#1d9fd2",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#f0b417",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#dc4e1e",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#70992f",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      },
      {
        title: "color name",
        hex: "#1d9fd2",
        rgb: {R: "222", G: "222", B: "222"},
        cmyk: {C: "001", M: "42", Y: "34", K: "23"},
        hsy: {H: "12", S: "22", Y: "23"},
      }
    ];

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbSportColorTeamComparison/sportTeamLogoModal/sportTeamLogoModalView.html",
    link: link,
    scope: {
      logodata: "=",
      index: "=",
      onClose: "&",
      closefunction: "=",
    },
  };
});
